import React from 'react'
import Router from 'next/router'

import Button from '@dashboard/components/Button'
import Card from '@dashboard/components/Card'
import HoverTile from '@dashboard/components/HoverTile'
import Flex from '@dashboard/components/Flex'

import Link from 'next/link'

import css from './styles.module.scss'

interface OwnProps {
  cta?: {
    text: string
    href?: string
    showSampleLink?: boolean
    onClick?: () => void
  }
}
interface State {}

export default class ProfileCTA extends React.Component<OwnProps, State> {
  constructor(props: OwnProps) {
    super(props)
  }

  render() {
    const { cta } = this.props

    return (
      <div className={css.noBreak}>
        <Card noPadding noBreaks>
          <div className={css.container}>
            <div className={css.header}>Why sign up for Crystal?</div>
            <div className={css.subtext}>
              Learn more about yourself, your friends and co-workers for free.
            </div>
            <Flex wrap justifyCenter>
              <HoverTile
                width={180}
                height={120}
                title="View your full profile"
                subtitle="Explore your own personality and learn about your natural strengths, motivations and more."
                img={'/static/share/images/profile.png'}
              />
              <HoverTile
                width={180}
                height={120}
                title="View friends and coworkers"
                subtitle="Invite friends, co-workers or anyone else to share their personality with you."
                img={'/static/share/images/people.png'}
              />
              <HoverTile
                width={180}
                height={120}
                title="See personalities in LinkedIn"
                subtitle="Use Crystal to predict anyone’s personality from their LinkedIn profile, even if you don’t know them yet."
                img={'/static/share/images/linkedin-short.jpg'}
              />
            </Flex>
            <div className={css.buttonWrapper}>
              <Flex vertical alignCenter>
                <Button onClick={this.handleClick}>
                  {cta?.text || 'See full profile'}
                </Button>
                {this.renderSampleLink()}
              </Flex>
            </div>
          </div>
        </Card>
      </div>
    )
  }

  renderSampleLink() {
    const { cta } = this.props

    if (!cta?.showSampleLink) return null

    return (
      <Link
        href="/p/bill-gates?show_as_own=true"
        target="_blank"
        rel="noopener noreferrer"
        className={css.sampleLink}
        passHref
      >
        View sample
      </Link>
    )
  }

  // Functions
  handleClick = () => {
    const { cta } = this.props

    if (cta?.href) Router.push(cta.href)
    else if (cta?.onClick) cta.onClick()
  }
}
